export default "__VITE_ASSET__DuCufR_m__"